import { useVoixToast } from "@voix/composables/useVoixToast";
import { useAdminStore } from "@voix/store/adminStore";
import { useHeadTagStore } from "@voix/store/headTagStore";
import { $voixNuxtApi } from "@voix/voix-layer/composables/voixNuxtApi";
function setHeadTagsInStore(response) {
  if (response) {
    const headTagStore = useHeadTagStore();
    headTagStore.setHeadTags(response);
  }
}
async function getHeadTags(variables) {
  const adminStore = useAdminStore();
  adminStore.isLoading = true;
  const query = new URLSearchParams(variables).toString();
  const request = await $voixNuxtApi(
    `/api/admin/voix/head-tags?${query.toString()}`
  );
  setHeadTagsInStore(request.data.value);
  adminStore.isLoading = false;
  return request;
}
function setHeadTagInStore(response) {
  if (response) {
    const headTagStore = useHeadTagStore();
    headTagStore.setHeadTag(response);
  }
}
async function getHeadTag(variables) {
  const adminStore = useAdminStore();
  adminStore.isLoading = true;
  const request = await $voixNuxtApi(
    `/api/admin/voix/head-tags/${variables.id}`
  );
  setHeadTagInStore(request.data.value);
  adminStore.isLoading = false;
  return request;
}
async function createHeadTag(variables) {
  const adminStore = useAdminStore();
  const voixToast = useVoixToast();
  adminStore.isLoading = true;
  const request = await $voixNuxtApi(
    `/api/admin/voix/head-tags`,
    {
      method: "POST",
      body: Object.assign({ page_id: 0 }, variables)
    }
  );
  adminStore.isLoading = false;
  if (request.data.value) {
    voixToast.add(`Head Tag Created: ${variables.type}`, "msg");
    return request;
  } else {
    throw new Error("Unable to save");
  }
}
async function updateHeadTag(variables) {
  const adminStore = useAdminStore();
  const voixToast = useVoixToast();
  adminStore.isLoading = true;
  const request = await $voixNuxtApi(
    `/api/admin/voix/head-tags/${variables.id}`,
    {
      method: "PUT",
      body: Object.assign({ page_id: 0 }, variables)
    }
  );
  adminStore.isLoading = false;
  if (request.data.value) {
    voixToast.add(`Head Tag Updated: ${variables.type}`, "msg");
    return request;
  } else {
    throw new Error("Unable to save");
  }
}
async function deleteHeadTag(variables) {
  const adminStore = useAdminStore();
  const voixToast = useVoixToast();
  adminStore.isLoading = true;
  const request = await $voixNuxtApi(
    `/api/admin/voix/head-tags/${variables.id}`,
    {
      method: "DELETE"
    }
  );
  adminStore.isLoading = false;
  if (request.data.value) {
    voixToast.add(`Head Tag Deleted`, "msg");
    return request;
  } else {
    throw new Error("Unable to save");
  }
}
export { createHeadTag, deleteHeadTag, getHeadTag, getHeadTags, updateHeadTag };
